<div class="field field-checkboxes d-flex flex-column" [class.hasOptionWidth]="!optionWidth || optionColumnWidth" [class.readOnly]="readOnly">
  @if (label) {
    <span class="label">{{label}} @if (optionalString) {
      <span>({{optionalString}})</span>
    }</span>
  }
  <div class="{{!optionWidth && optionColumnWidth ? 'row' : 'd-flex'}} options flex-wrap">
    @for (option of options; track option) {
      <div class="col-{{colSize || 'md'}}-{{(!optionWidth && optionColumnWidth) || ''}} option-wrap" [class.flex-grow-1]="fillWidth">
        <div [class.error-field]="localError" [ngStyle]="{'min-width': !optionColumnWidth && optionWidth ? (optionWidth + 'px') : 'auto'}" (click)="(check(option.value))" [class.active]="isActive(option.value)" [class.disabled]="option.disabled" [class.showBorder]="showBorder" class="field-checkbox-option app-tooltip-wrap flex-grow-1 d-flex align-items-center">
          <span class="fake-checkbox"></span> <span class="ellipsis option-title" [title]="option.title">{{option.title}}</span>
          @if (option.tooltip) {
            <div class="app-tooltip app-tooltip-default-centered">{{option.tooltip}}</div>
          }
        </div>
      </div>
    }
  </div>
  @if (localError) {
    <span class="error-field-display">{{localError}}</span>
  }
</div>